module.exports = __webpack_public_path__ + "static/media/logo.dfbe9b86.svg";